import { IconShoppingCartFilled } from '@tabler/icons-react';
import Image from '@components/Image';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Image
              className="h-[40px] w-[120px] object-contain"
              src={'/images/logos/logo.png'}
              alt="Business Logo"
            />
          </div>
          <div className="flex items-center">
            <IconShoppingCartFilled className="h-6 w-6 text-gray-700" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
